export enum TimeHorizon {
  IMMEDIATELY = 'IMMEDIATELY',
  NEXT_SIX_MONTHS = 'NEXT_SIX_MONTHS',
  NEXT_TWO_YEARS = 'NEXT_TWO_YEARS',
  LATER = 'LATER',
}

export enum TimeHorizonGermanString {
  IMMEDIATELY = 'Schnellstmöglich',
  NEXT_SIX_MONTHS = 'In den nächsten 6 Monaten',
  NEXT_TWO_YEARS = 'In den nächsten 2 Jahren',
  LATER = 'Später',
}
